import { FormikProps } from 'formik';
import { useState } from 'react';
import { projectsApiService } from '../../../../../../../../../graphql/projects/projectsApiService';
import { ComboFormState } from '../models/ComboFormState';
import { KeywordCalculation } from './useCalculateKeywords';

export type ExecuteBag = ReturnType<typeof useExecute>;

export function useExecute(
  formState: FormikProps<ComboFormState>,
  handleClose: () => void,
  projectId: number,
  wordCount: KeywordCalculation,
  reload: () => Promise<unknown>
) {
  // Process function
  const [loading, setLoading] = useState(false);
  const [executed, setExecuted] = useState(false);
  const processComboListFn = projectsApiService.mutations.googleAdsCombo.useProcessComboList();
  const handleProcessRequest = () => {
    setLoading(true);
    formState.submitForm().then(() => {
      processComboListFn({
        id: formState.values.id,
        googleAds: sessionStorage.getItem('google_ads_enabled') === 'true',
        projectId: projectId,
      })
        .then(reload)
        .finally(() => {
          setExecuteDialog(false);
          setLoading(false);
          setExecuted(true);
        });
    });
  };

  // Dialog logic
  const [executeDialog, setExecuteDialog] = useState(false);
  const handleExecuteDialogClose = () => setExecuteDialog(false);
  const handleTryExecuting = () => {
    if (wordCount.keywordCount > 700 * 10 * 30) {
      setExecuteDialog(true);
      return;
    }
    handleProcessRequest();
  };

  return {
    executeDialog,
    wordCount,
    loading,
    handleExecuteDialogClose,
    handleProcessRequest,
    handleTryExecuting,
    executed,
  };
}
